// @flow
const getExpires = (days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  return date;
};

export default getExpires;



// WEBPACK FOOTER //
// ../utilities/cookie/getExpires.js